import { combineEpics } from 'redux-observable'
import * as auth from './auth'
import * as socket from './socket'
import * as team from './team'
import * as participants from './participants'
import * as general from './general'
import * as reports from './reports'
import { signUpEpic, resetPasswordEpic, navigateAfterReset } from './signup'
import { inviteEmailEpic } from './invites'

export const rootEpic = combineEpics(
  auth.attemptEpic, auth.responseEpic, auth.failEpic, auth.syncEpic, auth.syncResEpic,
  auth.leaveHackathonEpic, auth.leaveRespEpic, auth.sendActivationCodeEpic, auth.sendCodeResEpic,
  auth.applyWebPushToken, auth.sendWebPushToken, auth.OneSignalSlowLoad, auth.applyWebPushTokenDelayed,
  socket.connectEpic, socket.initListenerEpic, socket.listenerEpic, socket.senderEpic,
  team.registerEpic, team.regResponseEpic, team.getAllEpic, team.getAllResponseEpic,
  team.joinEpic, team.joinResponseEpic, team.manageEpic, team.manageResEpic,
  team.getMineEpic, team.getMineResponse, team.deleteEpic, team.deleteResponseEpic,
  team.changeStatusEpic, team.changeStatusResEpic, team.changeLocationEpic, team.changeLocationResEpic,
  team.getSingleEpic, team.getSingleResEpic, team.changeTeamCommentEpic,
  participants.getEpic, participants.getResponseEpic, participants.manageProfileEpic,
  participants.changeAttendingStatusEpic, participants.changeCommentEpic, participants.changeLocationEpic,
  participants.changeLocationResEpic,
  general.getInitDataEpic, general.initDataResEpic, general.getAdminDataEpic, general.adminDataResEpic,
  reports.getPlayersReportEpic, reports.playersReportResEpic,
  signUpEpic,
  resetPasswordEpic,
  navigateAfterReset,
  inviteEmailEpic
)



// WEBPACK FOOTER //
// ./src/epics/index.js